import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout1 from "./Layouts/Layout1/Layout1";
import Privacy from "./Layouts/Privacy/Privacy";

// Theme & icons
import "./theme.scss";
import "./assets/css/materialdesignicons.min.css";
import "./assets/css/pe-icon-7.css";

function App() {
  return (
    <Routes>
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/" element={<Layout1 />} />
    </Routes>
  );
}

export default App;
